<!-- <form class="create-account-form" (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading">

    <dxi-item dataField="email" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Email', mode: 'email' }">
      <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
      <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
      <dxo-label [visible]="false"></dxo-label>
    </dxi-item>

    <dxi-item dataField="password" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Password', mode: 'password' }">
      <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
      <dxo-label [visible]="false"></dxo-label>
    </dxi-item>

    <dxi-item dataField="confirmedPassword" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Confirm Password', mode: 'password' }">
      <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
      <dxi-validation-rule type="custom" message="Passwords do not match" [validationCallback]="confirmPassword">
      </dxi-validation-rule>
      <dxo-label [visible]="false"></dxo-label>
    </dxi-item>

    <dxi-item>
      <div class='policy-info'>
        By creating an account, you agree to the <a routerLink="#">Terms of Service</a> and <a routerLink="#">Privacy
          Policy</a>
      </div>
    </dxi-item>

    <dxi-item itemType="button">
      <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'createAccountTemplate'">
      </dxo-button-options>
    </dxi-item>

    <dxi-item>
      <div class="login-link">
        Have an account? <a routerLink="/login">Sign In</a>
      </div>
    </dxi-item>

    <ng-container *dxTemplate="let item of 'createAccountTemplate'">
      <div>
        <span class="dx-button-text">
          <ng-container *ngIf="loading; else notLoading">
            <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
          </ng-container>
  
          <ng-template #notLoading>Create a new account</ng-template>
        </span>
      </div>
    </ng-container>

  </dx-form>
</form> -->

<div class="container">
  <app-stepper-wrapper [steps]="steps">
    <ng-template #step1Content> 
      <!-- Step 1 Content -->
      <dx-form [formData]="companyFormData">
        <dxi-item dataField="entityType" editorType="dxSelectBox"
          [editorOptions]="{ stylingMode: 'filled', items: entityTypes, placeholder: 'Entity Type' }">
          <dxi-validation-rule type="required" message="Entity Type is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="companyName" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Company Name' }">
          <dxi-validation-rule type="required" message="Company Name is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="registrationNumber" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Registration Number' }">
          <dxi-validation-rule type="required" message="Registration Number is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="saccraNumber" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'SACCRA Member Number' }">
        </dxi-item>
        <dxi-item dataField="ncrNumber" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'NCR Registration Number' }">
        </dxi-item>
      </dx-form>
    </ng-template>
    <ng-template #step2Content>
      <!-- Step 2 Content -->
      <dx-form [formData]="contactAddressFormData">
        <dxi-item dataField="contactPerson" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Contact Person' }">
          <dxi-validation-rule type="required" message="Contact Person is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="phone" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Phone' }">
          <dxi-validation-rule type="required" message="Phone is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="email" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Email', mode: 'email' }">
          <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
          <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
        </dxi-item>
      </dx-form>
    </ng-template>
    <ng-template #step3Content>
      <!-- Step 3 Content -->
      <dx-form [formData]="addressFormData">
        <dxi-item dataField="address" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Address' }">
          <dxi-validation-rule type="required" message="Address is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="unitComplex" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Unit Number & Complex' }">
        </dxi-item>
        <dxi-item dataField="streetName" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Number & Street Name' }">
          <dxi-validation-rule type="required" message="Street Name is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="suburb" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Suburb' }">
        </dxi-item>
        <dxi-item itemType="group" colCount="2">
          <dxi-item dataField="city" editorType="dxTextBox"
            [editorOptions]="{ stylingMode: 'filled', placeholder: 'City' }">
            <dxi-validation-rule type="required" message="City is required"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="code" editorType="dxTextBox"
            [editorOptions]="{ stylingMode: 'filled', placeholder: 'Code' }">
            <dxi-validation-rule type="required" message="Code is required"></dxi-validation-rule>
          </dxi-item>
        </dxi-item>
        <dxi-item dataField="country" editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Country' }">
          <dxi-validation-rule type="required" message="Country is required"></dxi-validation-rule>
        </dxi-item>
      </dx-form>
    </ng-template>
  </app-stepper-wrapper>
</div>
